// @Version: 1.0.0
import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { IFieldItem } from "../field-item.model";
import { FC_RADIO } from "./radio.model";


@Injectable({
   providedIn: 'root'
})

export class CustomValidators {

   public isValid (fg: FormGroup, fieldItem: IFieldItem): ValidatorFn {
      return (): ValidationErrors | null => {
         if (!fg.dirty && (!fg.value[FC_RADIO.RADIOBUTTON] || fg.value[FC_RADIO.RADIOBUTTON] && fg.value[FC_RADIO.RADIOBUTTON].length == 0)) return null;
         if (!fieldItem.valid || fieldItem.valid.length == 0 || fg.value[FC_RADIO.RADIOBUTTON] == null || fg.value[FC_RADIO.RADIOBUTTON] == '') return null;
         
         const valid =  fieldItem.valid.split(';');
         if (valid.length == 0) return null;
         return valid.findIndex(item => fg.value.radiobutton == item ) > -1 ? null : { valid: true };
      }
   }

   public isRequired (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => (fg.value[FC_RADIO.RADIOBUTTON] == null || fg.value[FC_RADIO.RADIOBUTTON] == undefined || fg.value[FC_RADIO.RADIOBUTTON] == '' || fg.value == '' || fg.value == undefined ||  fg.value == null ) ? { required: true } : null;  
   }

}
